export const gonvarri = {
  gonvarri: {
    chapa: {
      quantity: {
        title: 'Please specify how many sheets you want per package',
        warning: 'The package weight will be approximately ',
        minText: 'Minimum value',
        maxText: 'Maximum value'
      },
      raw: {
        title: 'For Eligible Weight Packages, please specify the maximum desired weight per package (KG):',
        minText: 'The minimum weight of the packages is',
        maxText: 'The maximum weight of the packages is'
      },
      ajustToStock: 'Adjust to available stock',
    },
    productSummary: {
      quantity: 'Quantity',
      price: 'Price'
    },
    quick: {
      inputs: {
        length: 'Length (MM)',
        weight: 'Package Weight (KG)',
        quantity: 'Number of Packages',
        sheets: 'Sheets / Package',
        lengthwarning: 'Please indicate the desired length (mm):',
        minlenght: 'Minimum value: {{minLenght}} mm',
        minWeight: 'Min. weight',
        maxWeight: 'Max. weight',
        packageWeight: 'Package of approx.',
      },
    },
    company: {
      addresses: {
        default: 'Set as default'
      }
    },
    header: {
      company: {
        users: 'Users',
        addresses: 'Addresses'
      }
    },
    product: {
      notification: 'Notify me when has stock',
      cancelNotification: 'Don\'t notify me'
    }
  }
};
